import script from "./PageTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageTitle.vue?vue&type=script&setup=true&lang=ts"

import "./PageTitle.vue?vue&type=style&index=0&id=87cd8ea8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87cd8ea8"]])

export default __exports__